<template>
  <el-dialog
    title="点位部件管理"
    :visible.sync="dialogVisible"
    width="720px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form
        :inline="true"
        label-position="top"
        :model="formInline"
        class="demo-form-inline"
        ref="form"
        :rules="rules"
      >
        <el-form-item label="部件类型" style="width: 100%;">
          <el-select
            v-model="formInline.partsType"
            placeholder="请选择部件类型"
          >
            <el-option
              v-for="item in partsTypeList"
              :key="item.id"
              :label="item.typeName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部件名称" style="width: 100%;">
          <el-input
            v-model="formInline.partsName"
            placeholder="请输入部件名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属社区" style="width: 100%;">
          <el-select
            v-model="formInline.communityCode"
            placeholder="请选择所属社区"
            @change="commcommunityChange"
          >
            <el-option
              v-for="item in commcommunityList"
              :key="item.id"
              :label="item.pointName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属网格" style="width: 100%;">
          <el-select
            v-model="formInline.blockCode"
            placeholder="请选择所属网格"
            @change="blockCodeChange"
          >
            <el-option
              v-for="item in blockList"
              :key="item.id"
              :label="item.pointName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属点位" style="width: 100%;">
          <el-select v-model="formInline.pointId" placeholder="请选择所属点位">
            <el-option
              v-for="item in pointOptions"
              :key="item.id"
              :label="item.pointName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="具体位置" style="width: 100%;">
          <el-input
            v-model="formInline.partsAddress"
            placeholder="请输入具体位置"
          ></el-input>
        </el-form-item>
        <el-form-item label="中心经度" style="width:210px;">
          <el-input v-model="formInline.partsLongitude" placeholder="中心经度">
            <template slot="append">°E</template>
          </el-input>
        </el-form-item>
        <el-form-item label="中心纬度" style="width:60%;">
          <div style="display:flex;">
            <el-input
              style="width:210px;"
              v-model="formInline.partsLatitude"
              placeholder="中心纬度"
            >
              <template slot="append">°N</template></el-input
            >
            <el-button
              @click="mapVisible = true"
              type="text"
              style="margin-left: 16px;"
              >地图定位</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="部件图片" style="margin-right:0;width:100%;">
          <el-upload
            class="avatar-uploader"
            action="#"
            :on-remove="handleRemove"
            :file-list="picFilesJson"
            list-type="picture-card"
            accept=".jpg"
            :limit="5"
            multiple
            :http-request="uploadPicFileFun"
          >
            <i style="font-size: 48px;" class="el-icon-upload"></i><br />
            <span class="el-upload__text"> 上传照片 </span><br />
            <span class="tip">
              只支持.jpg格式
            </span>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading"
        >确 定</el-button
      >
    </div>
    <mapSearch
      @cancel="mapVisible = false"
      @map-confirm="confirmLocation"
      :visible="mapVisible"
    ></mapSearch>
  </el-dialog>
</template>

<script>
import { uploadFile } from "@/api/block.js";
import {
  getblockAllByCommunityId,
  addPointParts,
  updatePointParts,
  getPointPartsById
} from "@/api/point.js";
import mapSearch from "@/components/map-search/index.vue";
import index from "../index";
import moment from "moment";
export default {
  components: { mapSearch },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  mixins: [index],
  data() {
    return {
      mapVisible: false,
      formInline: {
        partsType: "",
        communityCode: "",
        blockCode: "",
        pointId: "",
        pointName: "",
        partsAddress: "",
        partsLongitude: "",
        partsLatitude: "",
        partsName: "",
        id: ""
      },
      loading: false,
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        publicServiceType: [
          { required: true, message: "请选择类型", trigger: "blur" }
        ],
        communityCode: [
          { required: true, message: "请选择所属社区", trigger: "blur" }
        ],
        blockCode: [
          { required: true, message: "请选择所属网格", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        contacts: [
          { required: true, message: "请输入联系人", trigger: "blur" }
        ],
        contactsPhone: [
          { required: true, message: "请输入联系方式", trigger: "blur" }
        ]
      },
      picFilesJson: [],
      // partsUrls: [],
      pointOptions: []
    };
  },
  mounted() {
    if (this.curItem.id) {
      this.getPointPartsByIdFun();
    }
  },
  methods: {
    async blockCodeChange(id) {
      const res = await getblockAllByCommunityId({
        pid: id
      });
      this.pointOptions = res.data.data;
    },
    async getPointPartsByIdFun() {
      const res = await getPointPartsById({
        id: this.curItem.id
      });
      this.formInline = res.data.data;
      // if (this.formInline.deptCode) {
      //   // this.formInline.communityCode = this.formInline.deptCode.split("_")[0];
      //   // this.formInline.blockCode = this.formInline.deptCode.split("_")[1];
      // }

      if (this.formInline.communityCode)
        this.getblockAllByCommunityIdFun(this.formInline.communityCode);
      if (this.formInline.blockCode)
        this.blockCodeChange(this.formInline.blockCode);
      this.picFilesJson = [];
      if (this.formInline.partsUrls)
        this.picFilesJson = JSON.parse(this.formInline.partsUrls);
    },
    confirmLocation(e) {
      this.lnglat = e;
      this.formInline.partsLongitude = e.lng;
      this.formInline.partsLatitude = e.lat;
      this.formInline.partsAddress = e.addr;
      this.mapVisible = false;
    },
    handleRemove() {
      this.picFilesJson = [];
    },
    uploadPicFileFun(file) {
      if (!file.file.name.endsWith(".jpg")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.jpg",
          type: "warning"
        });
        return;
      }
      this.uploadFileFun(file, "gh_block_organization");
    },
    async uploadFileFun(file, type) {
      let formData = new FormData();
      formData.append("file", file.file);
      formData.append("objectName", type);
      const res = await uploadFile(formData);
      if (res.data.code === 200) {
        this.picFilesJson.push({
          ...res.data.data,
          name: res.data.data.fileName,
          url:
            process.env.VUE_APP_API_DOMAIN +
            "/unified-code/file/download?filePath=" +
            res.data.data.filePath
        });
      }
    },
    async onSubmit() {
      let xx = true;
      this.$refs["form"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      this.loading = true;
      let res = null;
      if (this.curItem.id) {
        res = await updatePointParts({
          ...this.formInline,
          pointTypes: null,
          partsUrls: JSON.stringify(this.picFilesJson)
        });
      } else {
        res = await addPointParts({
          ...this.formInline,
          partsUrls: JSON.stringify(this.picFilesJson)
        });
      }
      this.loading = false;
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    }
  },
  computed: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

.container-dialog {
  padding: 14px 24px 24px;
}
/deep/.el-form-item {
  width: calc(50% - 12px);
  margin-bottom: 20px;
  margin-right: 8px;
  .el-form-item__label {
    margin: 0;
    padding: 0;
    margin-bottom: 8px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #494c4f;
    line-height: 1;
  }
  .el-select {
    width: 100%;
  }
  .el-input__inner {
    height: 40px;
    width: 100%;
  }
}
/deep/.demo-drawer__footer {
  width: 100%;
  padding: 24px;
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  background: #fff;
}
/deep/.el-upload,
/deep/.el-upload-dragger {
  width: 212px;
  height: 212px;
}
/deep/.el-upload .el-upload__input {
  display: none;
}
.el-upload__text {
  height: auto;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 16px;
  color: #494c4f;
  display: inline-block;
  margin: 8px 0;
}
.tip {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #92979c;
  margin-top: 8px;
}
/deep/.el-upload--picture-card {
  line-height: 1;
  padding-top: 54px;
}
.list-pic {
  /deep/.el-upload--picture-card {
    display: none;
  }
  /deep/.el-upload-list--picture-card {
    img {
      width: 212px;
      height: 212px;
    }
  }
}
/deep/.container-dialog {
  padding-bottom: 112px;
}
/deep/.avatar-uploader {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/pages/point/pointParts/components/addDialog.vue